import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { CustomerBo } from '@utils/types/back-office/customer-bo.ts';
import Input from '@components/atoms/ui-kit/input.tsx';
import PageHeader from '@components/layout/page-header.tsx';

interface Props {
  register: UseFormRegister<CustomerBo>;
  errors: FieldErrors<CustomerBo>;
  customer?: CustomerBo;
  cardStyle: React.CSSProperties;
}

export function CustomerAdvancedTab({
  register,
  errors,
  customer,
  cardStyle
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="py-4">
      <div
        className="rounded-2xl border shadow-card p-4 sm:p-6"
        style={cardStyle}
      >
        <PageHeader
          title={t('advanced-details')}
          caption="Technical integration IDs and external system references"
          className="border-b-0 mb-4"
          contentClassName="px-0 py-0"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 lg:gap-6">
          <Input
            id="microsoft_tid"
            label={t('Microsoft Azure AD Tenant ID')}
            defaultValue={customer?.microsoft_tid || ''}
            type="text"
            autoComplete="micorosoft-tid"
            {...register('microsoft_tid')}
            error={errors?.microsoft_tid?.message}
          />
          <Input
            id="mollie_id"
            label={t('Mollie Customer ID')}
            defaultValue={customer?.mollie_id || ''}
            type="text"
            autoComplete="mollie-id"
            {...register('mollie_id')}
            error={errors?.mollie_id?.message}
          />
          <Input
            id="jortt_id"
            label={t('Jortt Customer ID')}
            defaultValue={customer?.jortt_id || ''}
            type="text"
            autoComplete="jortt-id"
            {...register('jortt_id')}
            error={errors?.jortt_id?.message}
          />
          <Input
            id="wefact_id"
            label={t('We Fact Customer ID')}
            defaultValue={customer?.wefact_id || ''}
            type="text"
            autoComplete="we-fact-id"
            {...register('wefact_id')}
            error={errors?.wefact_id?.message}
          />
        </div>
      </div>
    </div>
  );
}
